// extracted by mini-css-extract-plugin
var _1 = "PlacementLevelChangeModal-module__buttons--ohx8y";
var _2 = "PlacementLevelChangeModal-module__modalDescription--YwNQQ";
var _3 = "PlacementLevelChangeModal-module__modalHeadmaster--Inira";
var _4 = "PlacementLevelChangeModal-module__modalTitle--SItoS";
var _5 = "PlacementLevelChangeModal-module__placementTestModal--jUkJv";
export { _1 as "buttons", _2 as "modalDescription", _3 as "modalHeadmaster", _4 as "modalTitle", _5 as "placementTestModal" }
